import { Breadcrumbs, Button, Container, Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import { Home } from "@material-ui/icons";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { AuthUserContext, withAuthorization } from "../Session";
import UserProfile from "./UserProfile";
import * as ROUTES from "../../constants/routes";
import { useTranslation } from "react-i18next";
import { grey } from "@material-ui/core/colors";
import Footer from "../Footer";

const UserProfileScreen = () => {
  const history = useHistory();
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={2} justifyContent="center" style={{ marginBottom: 24, paddingBottom: 0 }}>
        <Grid container item xs={12} lg={7} className={styles.headerContainer}>
          <Breadcrumbs className={styles.breadcrumbs}>
            <Link
              color="inherit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push(ROUTES.HOME);
                window.scrollTo(0, 0);
              }}
            >
              <div style={{ display: "flex" }}>
                <Home style={{ paddingBottom: 8, paddingRight: 4 }} />
                <Typography style={{ paddingTop: 4, textDecoration: "underline" }}>{t("curso_Online")}</Typography>
              </div>
            </Link>
          </Breadcrumbs>
        </Grid>
        <AuthUserContext.Consumer>{(authUser) => <UserProfile uid={authUser.uid} />}</AuthUserContext.Consumer>
      </Grid>
      <Footer />
    </>
  );
};

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(UserProfileScreen);

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: 24,
      paddingTop: 32,
    },
    [theme.breakpoints.down("md")]: {
      margin: 12,
      paddingTop: 20,
    },
  },
  breadcrumbs: {
    [theme.breakpoints.down("md")]: {
      //marginTop: -20,
      marginBottom: -32,
    },
  },
}));
